import styled from "styled-components";
import {UserMenuRootDefaultBox} from "./user-menu-root.default.box";

export const UserMenuRootCasino777Box = styled(UserMenuRootDefaultBox)`
  background: linear-gradient(#8ad0b8 25%, #cce6c9 70%, #fcf6d5);
`